﻿interface RecaudacionData {
  periodLabel: string;
  totalRecaudado: number;
  totalPendiente: number;
  totalVencido: number;
}

interface RecaudacionChartProps {
  data: RecaudacionData;
}

export default function RecaudacionChart({ data }: RecaudacionChartProps) {
  const total = Math.max(data.totalRecaudado + data.totalPendiente + data.totalVencido, 1);
  const pagadoPct = Math.round((data.totalRecaudado / total) * 100);
  const pendientePct = Math.round((data.totalPendiente / total) * 100);
  const vencidoPct = Math.max(0, 100 - pagadoPct - pendientePct);

  const segments = [
    { label: "Pagado", pct: pagadoPct, color: "#10b981", amount: data.totalRecaudado },
    { label: "Pendiente", pct: pendientePct, color: "#f59e0b", amount: data.totalPendiente },
    { label: "Vencido", pct: vencidoPct, color: "#ef4444", amount: data.totalVencido },
  ];

  let cumulative = 0;
  const gradientParts = segments.map((segment) => {
    const start = cumulative;
    cumulative += segment.pct;
    return `${segment.color} ${start}% ${cumulative}%`;
  });
  const gradient = `conic-gradient(${gradientParts.join(", ")})`;

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5">
      <div className="mb-5">
        <h3 className="font-semibold text-gray-800">Estado de Recaudación</h3>
        <p className="text-xs text-gray-400 mt-0.5">Período actual - {data.periodLabel}</p>
      </div>
      <div className="flex items-center gap-6">
        <div className="relative flex-shrink-0">
          <div className="w-28 h-28 rounded-full" style={{ background: gradient }} />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 rounded-full bg-white flex flex-col items-center justify-center">
              <span className="text-xs font-bold text-gray-800">{pagadoPct}%</span>
              <span className="text-xs text-gray-400">cobrado</span>
            </div>
          </div>
        </div>

        <div className="flex-1 space-y-3">
          {segments.map((segment) => (
            <div key={segment.label} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: segment.color }} />
                <span className="text-xs text-gray-600">{segment.label}</span>
              </div>
              <div className="text-right">
                <div className="text-xs font-semibold text-gray-800">${segment.amount.toLocaleString("es-CL")}</div>
                <div className="text-xs text-gray-400">{segment.pct}%</div>
              </div>
            </div>
          ))}
          <div className="pt-2 border-t border-gray-100">
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-500 font-medium">Total emitido</span>
              <span className="text-xs font-bold text-gray-800">${total.toLocaleString("es-CL")}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
